import { useContext } from 'react';

import { FileUploaderContext } from '..';

export const useFileUploaderContext = () => useContext(FileUploaderContext);
